import { loadScript } from "lib/utils/helpers";

const PLURAL_SDK_URL = "https://checkout.pluralonline.com/v3/web-sdk-checkout.js";

export const loadPluralDefaultSdk = async () => {
  if ((window as any).Plural) return true;
  try {
    return await loadScript(PLURAL_SDK_URL, () => {});
  } catch (e) {
    console.error(e);
    throw e;
  }
};

const forceFullViewportSize = () => {
  const modal = document.getElementById("plural-modal");
  const iframe = document.getElementById("plural-iframe");
  if (modal) {
    modal.style.width = "100vw";
    modal.style.height = "100vh";
  }
  if (iframe) {
    iframe.style.width = "100vw";
    iframe.style.height = "100vh";
  }
};

interface PluralDefaultPayment {
  redirectUrl: string;
  onSuccessHandler: (response: any) => void;
  onFailureHandler: (response: any) => void;
}

export const initializePluralDefaultPayment = ({
  redirectUrl,
  onSuccessHandler,
  onFailureHandler,
}: PluralDefaultPayment) => {
  const options = {
    redirectUrl,
    successHandler: onSuccessHandler,
    failedHandler: onFailureHandler,
  };
  const plural = new (window as any).Plural(options);
  plural.open();
  forceFullViewportSize();
};